import React from "react";
import HTMLFlipBook from 'react-pageflip';

const Modal = ({ title = '', content, handleModal, ...props }) => {

     function manageModal() {
          handleModal();
     }

     return (<div className="absolute top-0 left-0 flex flex-col items-center justify-center w-screen h-screen p-4 bg-slate-800/50">
          <div className="relative w-full p-4 bg-white rounded">
               <a onClick={manageModal} className="absolute flex items-center justify-center w-8 h-8 rounded-full right-5 text-emerald-700 hover:cursor-pointer bg-emerald-100 hover:bg-emerald-300">X</a>
               {title != '' ? <div>
                    <h1 className="text-lg font-semibold text-emerald-700">{title}</h1>
               </div> : null}
               <div className="flex flex-col items-center w-full mt-4">
                    <HTMLFlipBook width={300} height={500}>
                         {content.map((page, i) => {
                              return <div className="overflow-hidden page" key={`page-${i}`}>
                                   <img src={page} className="w-auto h-full" />
                              </div>
                         })}
                    </HTMLFlipBook>
               </div>
          </div>
     </div>);
}

export default Modal;